import React, { ReactNode } from 'react'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { Empty } from 'antd'
import './NotFound.less'

const NotFound: React.FC<INotFoundProps> = (props) => {
  return (
    <div className={classNames('not-found', props.className)}>
      <Empty description={props.description || '找不到该页面'} />
    </div>
  )
}

interface INotFoundProps {
  className?: ClassValue
  description?: ReactNode
}

export default NotFound
